var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _circle3, _circle4, _circle5, _path9, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicBubbles2Colors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 500 500",
    preserveAspectRatio: "none",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 82.5L112 82.5L112 297.804",
    stroke: "#2D7D88",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194 82.3916L126 82.3916L126 298",
    stroke: "#9B4578",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 23.5L119.169 23.5L119.169 298",
    stroke: "#9B4578",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 150.464L104.5 150.464L104.5 223.464L104.5 297.964",
    stroke: "#2D7D88",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 225.51L97.5 225.51L97.5 259.464L97.5 297.964",
    stroke: "#2D7D88",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184 81C184 91.4934 175.493 100 165 100C154.507 100 146 91.4934 146 81C146 70.5066 154.507 62 165 62C175.493 62 184 70.5066 184 81Z",
    fill: "#CCCCCC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 80.4644,
    r: 19,
    fill: "#CCCCCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 80.9644,
    r: 22.5,
    fill: "#2D7D88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236 81.304C236 93.7304 225.926 103.804 213.5 103.804C201.074 103.804 191 93.7304 191 81.304C191 68.8776 201.074 58.804 213.5 58.804C225.926 58.804 236 68.8776 236 81.304Z",
    fill: "#9B4578"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 150.964C46 163.391 35.9264 173.464 23.5 173.464C11.0736 173.464 1 163.391 1 150.964C1 138.538 11.0736 128.464 23.5 128.464C35.9264 128.464 46 138.538 46 150.964Z",
    fill: "#2D7D88"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 226.964,
    r: 22.5,
    fill: "#2D7D88"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 150.464,
    r: 19,
    fill: "#CCCCCC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 225.464,
    r: 19,
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236 23.5C236 35.9264 225.926 46 213.5 46C201.074 46 191 35.9264 191 23.5C191 11.0736 201.074 1 213.5 1C225.926 1 236 11.0736 236 23.5Z",
    fill: "#9B4578"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 23,
    r: 19,
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicBubbles2Colors);
export default __webpack_public_path__ + "static/media/TopicBubbles2Colors.ddb7be65729f25ee8422c4a3c2b05ac7.svg";
export { ForwardRef as ReactComponent };